import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getCourses() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}courses`);
    return response

  } catch (error) {
    console.error('Error al obtener los cursos', error);
  }
}